export const NOTIFICATIONS_PANEL_ID = "notifications_panel";
